import React, { useEffect, useState } from "react";
import { getUserPolicy } from "../../../Services/userFromServices";
import useVendorStore from "../../../AuthStore/store/authStore";
import AlertModal from "../../Modal/AlertModel";


const MyPolicy = () => {
  const { authToken } = useVendorStore();
  const [policydata, setPolicydata] = useState([]);

  // modal states
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const fetchPolicyData = async () => {
      try {
        const res = await getUserPolicy(authToken);
        setPolicydata(res.data); // API response is array
      } catch (error) {
        console.error("Fetching data Error in My Policy Ui: ", error);

        // show modal instead of window.alert
        setErrorMsg(error.message || "Failed to fetch policy data");
        setOpen(true);
      }
    };
    fetchPolicyData();
  }, [authToken]);

  return (
    <div>
      <div className="bg-white shadow rounded-lg p-6 overflow-x-auto">
        <h3 className="text-lg font-medium text-gray-900 mb-4">My Policies</h3>
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Policy ID
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Policy Name
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Type
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Amount
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Status
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Min Tenure
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Nominee
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {policydata.map((policy) => (
              <tr key={policy.id}>
                <td className="px-4 py-3 text-sm">{policy.id}</td>
                <td className="px-4 py-3 text-sm">{policy.policy_name}</td>
                <td className="px-4 py-3 text-sm">{policy.type}</td>
                <td className="px-4 py-3 text-sm">₹{policy.amount}</td>
                <td className="px-4 py-3 text-sm">
                  <span
                    className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      policy.status === "active"
                        ? "bg-green-100 text-green-800"
                        : policy.status === "pending"
                        ? "bg-yellow-100 text-yellow-800"
                        : "bg-red-100 text-red-800"
                    }`}
                  >
                    {policy.status}
                  </span>
                </td>
                <td className="px-4 py-3 text-sm">{policy.min_tenure} years</td>
                <td className="px-4 py-3 text-sm">
                  {policy.nominee_name} ({policy.nominee_relation})
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 🔔 Alert Modal for errors */}
      <AlertModal
        isOpen={open}
        onClose={() => setOpen(false)}
        title="Error!"
        message={`Error fetching policies: ${errorMsg}`}
        type="error"
      />
    </div>
  );
};

export default MyPolicy;
